import { IconBoxModel2, IconBrandSuperhuman, IconCalendarFilled, IconChartBar, IconChevronCompactDown, IconChevronLeft, IconChevronRight, IconChevronsLeft, IconChevronsRight, IconDeviceProjector, IconHome, IconRegistered, IconSettings, IconSquarePercentage, IconSquaresFilled, IconTir, IconUser, IconUsers } from '@tabler/icons-react'
import React from 'react'
import { Link, NavLink } from 'react-router-dom'
import { useConfigurationRQ } from '../queryState/configuration.state'
import { useSelector } from 'react-redux'
import { RootState } from '../redux/store'
import { useSideNavAPI } from '../API/sideNavAPI'
import { ScrollArea } from '../shadcn/ui/scroll-area'
import { ButtonIconSquare } from './buttons'
import { useGetAllowedMenus } from 'src/API/rest.role'
import { isAllowedPermission } from 'src/lib/utils'

export interface NavbarButtonProps {
    icon: React.ReactNode,
    text: string,
    isSelected: boolean,
    href: string,
    isCollapsed?: boolean,
    permissionId: string
}

export function NavbarButton({
    icon,
    text,
    isSelected,
    href,
    isCollapsed
}: NavbarButtonProps) {
    const [isActive, setActive] = React.useState(false)

    return (
        <NavLink to={href} className={(
            state
        ) => {
            setActive(state.isActive)
            return ` ${isCollapsed ? 'justify-center' : 'justify-start px-3'} ${state.isActive ? 'bg-white text-white  dark:bg-white/50 shadow-sm' : ''} flex gap-2 items-center  w-full py-3 px-1 hover:bg-white dark:hover:bg-white/50 rounded-xl text-xs`
        }}>
            <div className={`${isActive ? 'bg-vstarPrimary-500' : 'bg-white'} w-[35px] h-[35px]  rounded-[13px] flex items-center justify-center overflow-hidden`}>{icon}</div>
            <span className={`text-xs font-medium text-black whitespace-nowrap truncate ${isCollapsed ? 'hidden' : ''} ${isActive ? ' dark:text-vstargray-100' : 'dark:text-vstargray-300'} `}>{text}</span>
        </NavLink >
    )
}

export default function SideNavbar() {

    const {
        hideSideNav,
        collapseSideNav,
        showSideNav,
        unCollapseSideNav,
        sideNavState,
        sideNavCollapseState
    } = useSideNavAPI()

    const MasterSideNavBars: NavbarButtonProps[] = [
        
        {
            icon: <IconDeviceProjector />,
            text: 'Product',
            isSelected: false,
            href: 'master/product',
            permissionId: 'productID'
        },


    ]



    return (
        <>
            <nav style={{
                left: sideNavState === 'open' ? '0' : '-230px',
                top: 0,
                bottom: 0
            }} className={` transition-all overflow-hidden duration-100 z-50 min-h-screen ${sideNavCollapseState === 'open' ? 'w-[230px] max-w-[230px] min-w-[230px]  px-4' : 'w-[80px] max-w-[80px] min-w-[80px] px-1'} py-1 fixed bg-vstargray-200 sm:bg-transparent  sm:sticky border-r sm:border-none border-vstargray-400 shadow-lg sm:shadow-none`}>
                <ScrollArea type='always' className={`sample h-full w-full  ${sideNavCollapseState === 'open' ? 'pb-14' : ' pb-24'}`}>
                    <div className=' pe-4'>
                        <div className=' w-full flex justify-center py-5 '>
                            <img className=' w-[140px] object-cover h-[30px]' style={{ display: sideNavCollapseState === 'open' ? 'block' : 'none' }} src="/assets/logo/logo_big.png" alt="" />
                            <img className=' w-[40px] object-cover h-[30px]' style={{ display: sideNavCollapseState === 'close' ? 'block' : 'none' }} src="/assets/logo/logo_small.png" alt="" />
                        </div>
                        <div className='h-[1px] bg-gradient-to-r from-transparent via-white to-transparent rounded-full'></div>
                        <div className=' w-full flex flex-col gap-2 pt-5'>
                            {/* <NavbarButton isSelected={true} icon={<IconHome/>} text='Dashboard' /> */}
                            
                        </div>

                        {
                            true ?
                                <>
                                    {sideNavCollapseState === 'open' ?
                                        <p className=' uppercase text-sm font-semibold px-3  dark:text-vstargray-600 min-h-8 max-h-8 flex items-center'></p>
                                        :
                                        <p className=' uppercase text-xl font-semibold px-3  dark:text-vstargray-600 text-center min-h-8 max-h-8 flex items-center justify-center'></p>}
                                    <div className=' w-full flex flex-col gap-2'>
                                        {/* <NavbarButton isSelected={true} icon={<IconHome/>} text='Dashboard' /> */}
                                        {
                                            MasterSideNavBars.map((item, index) => <NavbarButton {...item} isCollapsed={sideNavCollapseState === 'close'} key={index} />)
                                        }
                                    </div>
                                </>
                                : null}

                        
                        {
                            true ?
                                <>
                                    {sideNavCollapseState === 'open' ?
                                        <p className=' uppercase text-sm font-semibold px-3  dark:text-vstargray-600 min-h-8 max-h-8 flex items-center'></p>
                                        :
                                        <p className=' uppercase text-xl font-semibold px-3  dark:text-vstargray-600 text-center min-h-8 max-h-8 flex items-center justify-center'></p>}
                                    
                                </>
                                : null}
                        <div className=' absolute bottom-0 py-2 pe-3 flex justify-between w-full'>
                            <div className={` ${sideNavCollapseState === 'open' ? 'flex-row' : ' flex-col'} flex gap-2 items-center w-full  `}>
                                <IconSettings className=' dark:text-white' />
                                {
                                    sideNavCollapseState === 'open'
                                        ?
                                        <div className=' text-xs grow dark:text-vstargray-100'>Settings</div>
                                        :
                                        null
                                }
                                {sideNavCollapseState === 'open'
                                    ?
                                    <ButtonIconSquare onClick={collapseSideNav} icon={<IconChevronsLeft />} />
                                    :
                                    <ButtonIconSquare onClick={unCollapseSideNav} icon={<IconChevronsRight />} />
                                }
                            </div>
                        </div>
                    </div>
                </ScrollArea>
                {/* bottom buttons */}
            </nav>
            {/* overlay */}
            <div style={{
                zIndex: 10,
                position: 'fixed',
            }} onClick={hideSideNav} className={`fixed inset-0 ${sideNavState === 'open' ? ' block sm:hidden' : ' hidden'}`}></div>
        </>
    )
}
